import { z } from "zod";
import { AudienceCriteria } from "@/modules/emailManagement/features/EmailAudienceBuilder/types/audienceTypes";

// Zod schema for audience filter
const audienceFilterSchema = z.object({
  id: z.string(),
  fieldId: z.string(),
  operator: z.string(),
  value: z.union([
    z.string(),
    z.number(),
    z.boolean(),
    z.array(z.string()),
    z.array(z.number()),
    z.object({ from: z.union([z.string(), z.number()]), to: z.union([z.string(), z.number()]) }),
    z.null(),
  ]),
});

const filterGroupSchema = z.object({
  id: z.string(),
  logic: z.enum(["AND", "OR"]),
  filters: z.array(audienceFilterSchema),
});

const audienceCriteriaSchema = z.object({
  type: z.enum(["active", "static"]),
  groupLogic: z.enum(["AND", "OR"]),
  filterGroups: z.array(filterGroupSchema),
  excludeEmails: z.array(z.string()).optional(),
});

export const EmailCampaignFormSchema = z.object({
  name: z.string().min(1, "Campaign name is required"),
  description: z.string().nullable(),
  emailTemplate: z
    .object({
      id: z.number(),
      name: z.string(),
    })
    .nullable()
    .refine((val) => val !== null, "Email template is required"),
  emailSubject: z.string().nullable(),
  event: z
    .object({
      id: z.number(),
      name: z.string(),
    })
    .nullable()
    .refine((val) => val !== null, "Event is required"),
  session: z
    .object({
      id: z.number(),
      name: z.string(),
    })
    .nullable()
    .refine((val) => val !== null, "Event session is required"),
  sendOption: z
    .object({
      id: z.number(),
      name: z.string(),
    })
    .nullable()
    .refine((val) => val !== null, "Send option is required"),
  // Audience segmentation criteria (optional - filters applied on top of session enrollees)
  audienceCriteria: audienceCriteriaSchema.nullable(),
});

export type EmailCampaignFormData = z.infer<typeof EmailCampaignFormSchema>;
